import Glide from '@glidejs/glide';

function initCarousel(el, opts = {}) {
  // console.log('initing carousel', el);
  return new Glide(el, {
    type: 'carousel',
    autoplay: false,
    ...opts,
  }).mount();
}

export { initCarousel };
